import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Shop by Category
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md leading-relaxed">
              Browse our carefully organized pandabuy spreadsheet categories. Each category links directly to curated product lists on kaspreadsheet.com.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap group"
          >
            Explore All
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-2xl overflow-hidden border border-background-200 bg-white hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="relative h-36 sm:h-40 overflow-hidden bg-background-100">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              </div>
              <div className="px-3 py-3 flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 flex-shrink-0">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                <span className="text-xs font-semibold text-foreground-800 group-hover:text-foreground-950 transition-colors leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}